import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class SpinnerService {
    private spinnerCache = new Map<string, boolean>();

    register(spinnerName: string): void {
        this.spinnerCache.set(spinnerName, false);
    }

    show(spinnerName: string): void {
        if (this.spinnerCache.has(spinnerName)) {
          this.spinnerCache.set(spinnerName, true);
        }
    }

    state(spinnerName: string): boolean {
      return this.spinnerCache.get(spinnerName) || false;
    }

    hide(spinnerName: string): void {
      if (this.spinnerCache.has(spinnerName)) {
        this.spinnerCache.set(spinnerName, false);
      }
    }

    unregister(spinnerName: string): void {
      if (this.spinnerCache.has(spinnerName)) {
        this.spinnerCache.delete(spinnerName);
      }
    }
}
